/**
 * @fileOverview This file contains the implementation of the ClientAutocomplete component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../../globalVar';
import customAxios from '../../utils/customAxios';
//#endregion

const ClientAutocomplete = ({ setClient }) => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await customAxios.get(
          `${GlobalVariables.getURL()}listClients/`,
          {
            headers: {
              Authorization: 'bearer ' + localStorage.getItem('token'),
            },
          }
        );
        setClients(response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    fetchClients();
  }, []);

  return (
    <Autocomplete
      options={clients}
      sx={{ width: '100%' }}
      getOptionLabel={(client) => client.business_name}
      getOptionSelected={(client, value) => client.id === value.id}
      renderInput={(params) => (
        <TextField {...params} label="Seleccionar Plaza..." required />
      )}
      onChange={(event, newValue) => {
        setClient(newValue.id);
      }}
      ListboxProps={{ style: { maxHeight: '15rem' } }}
    />
  );
};

export default ClientAutocomplete;
